import { NormalizedButtonPropsCombined } from "./";

export const HOVER_KEY = "backgroundColorHover";
export const BACKGROUND_COLOR = "backgroundColor";
export const BORDER_COLOR = "borderColor";
export const propertiesAllowed = {
  [BACKGROUND_COLOR]: true,
  [HOVER_KEY]: true,
  [BORDER_COLOR]: true,
  color: true
};

interface Properties {
  [key: string]: string;
}

interface PropertiesAllowed {
  [key: string]: boolean;
}

export const makeOverride = (properties: Properties = {}, allowed: PropertiesAllowed) => {
  return Object.keys(properties).reduce((props: any, propName) => {
    if (allowed.hasOwnProperty(propName)) {
      const value = properties[propName];
      if (propName === BORDER_COLOR) {
        props.border = `1px solid ${value}`;
        return props;
      }
      if (propName === HOVER_KEY) {
        props["&:hover"] = {
          [BACKGROUND_COLOR]: value,
          "@media (hover: none)": {
            [BACKGROUND_COLOR]: value
          }
        };
        return props;
      }
      props[propName] = value;
    }
    return props;
  }, {});
};

export const isButtonDefine = (buttonProps: NormalizedButtonPropsCombined) =>
  Boolean(buttonProps && buttonProps.hasOwnProperty("label"));
